<div #wrapper class="upgrade-wrapper">
    <div class="modal-body">
        <div class="logo-body">
            <img class="logo" src="assets/images/logo.svg" alt="agaia logo"/>

            <i class="close-shortcuts ti-close" (click)="bsModalRef.hide()"></i>
        </div>

        <div class="datepicker-wrapper2" [ngClass]="isIOS() === true ? 'ios' : ''" *ngIf="dateObj">
            <button type="button" class="btn btn-icon" (click)="onDateBackwards()">
                <div class="responsive-flex-wrapper">
                    <i class="ti-angle-left"></i>
                </div>
            </button>

            <div class="current-date">
                <app-datepicker #datepicker [date]="dateObj" (dateChanged)="onDateChanged($event)"></app-datepicker>
            </div>

            <button type="button" class="btn btn-icon" (click)="onDateForwards()">
                <div class="responsive-flex-wrapper">
                    <i class="ti-angle-right"></i>
                </div>
            </button>
        </div>

        <app-alerts-components
                *ngIf="showNotFound"
                [disableClose]="true"
                [icon]="'fa fa-info-circle'"
                [id]="'recipes-text' + rand() "
                [title]="'recipes_text_not_found_title' | localise"
                [message]="'recipes_text_not_found_text' | localise"></app-alerts-components>

        <div class="recipe" *ngFor="let recipe of diaryRecipes">
            <h2 class="recipe-text-title">{{ recipe.recipe.title }}</h2>

            <div
                    *ngIf="recipe.images.length > 0"
                    [lazyLoad]="constants.imagesUrl() + '/images/850x500/' + recipe.images[0].type + '/' + recipe.images[0].name"
                    class="main-image animated fadeIn">
            </div>

            <div class="recipe-text" [innerHTML]="recipe.recipe.how_to_cook_text | keepHtml"></div>
        </div>
    </div>
</div>
